import { Stack, Typography } from '@mui/material'
import { BuyIcon } from '../../assets/icons/icons';

import styles from './BuyButton.module.scss';

interface BuyButtonProps {
  buy_link: string;
}

const BuyButton = (props: BuyButtonProps) => {

  return (
    <a className={styles.buyButtonContainer} href={props.buy_link} target='_blank'>
      <Stack justifyContent={"center"} alignItems={"center"} sx={{ color: "white" }}>
        <BuyIcon />
        <Typography sx={{ color: "black" }} variant='customBodyXsCondensed'>buy it</Typography>
      </Stack>
    </a>
  )
}

export default BuyButton